<template lang="pug">
  .home
    .home__banner
      .home__banner_center-text
        v-row(justify="center")
          v-col.text-center(cols="12")
            img.image(src='@/assets/img/svg/logo-min-white.svg')
          v-col.text-center(cols="12")
            h1.white--text Totem de
              br
              | autoatendimento
    .home__cards-content.max-content
      v-row(justify="center")
        v-col.text-center(cols="12")
          img.image(src='@/assets/img/svg/logo-default.svg')
        v-col.text-center(cols="12")
          h2.primary--text.font-weight-regular Solução 
            strong inteligente
            |  para
            strong  recebimentos.
      v-row(justify="center")
        v-col.text-center(
          v-for="(card, index) in cards"
          :key="index"
          cols="10"
          sm="5"
          md="3"
        )
          card-home(:card="card")
    .home__totem-content
      .home__totem-line
        .totem-text.white--text.text-center
          h3 Totem
            br
            | personalizado.
          v-btn.primary--text.text-capitalize.font-weight-black(rounded :to="{ name: 'Product' }") Saiba Mais!
      img.image(src='@/assets/img/svg/home-totem.svg')
    .home__rbx-content.mt-6
      v-row(justify="center")
        v-col.text-center(cols="12")
          h3.primary--text.font-weight-regular Integração com o sistema:
        v-col.text-center(cols="12")
          img.image(src='@/assets/img/svg/logo-rbxsoft.svg')
    .home__banner-2
      .home__banner-2_text.white--text.text-center
        h3 Fale com um consultor
          br
          | e conheça todas as
          br
          | vantagens.
        v-btn.text-capitalize.font-weight-black.primary(rounded dark :to="{ name: 'Contact' }") Clique Aqui!
</template>

<script>
import CardHome from '@/components/CardHome.vue'

export default {
  name: 'home-page',
  components: {
    CardHome
  },
  data: () => ({
    cards: [
      {
        icon: require('@/assets/img/svg/home-card1.svg'),
        htmlText: '- Atendente<br> + Agilidade<br> + Comodidade<br> + Facilidade<br>',
      },
      {
        icon: require('@/assets/img/svg/home-card2.svg'),
        htmlText: 'Segurança na hora do recebimento para o seu negócio.',
      },
      {
        icon: require('@/assets/img/svg/home-card3.svg'),
        htmlText: 'Facilidade para o seu cliente.',
      },
    ]
  })
}
</script>

<style lang="sass" scoped>
@import "@/assets/style/mobileFirst.sass"
@import "@/assets/style/variables.sass"

.home
  background: $white
  &__banner
    min-height: 450px
    background-position: center
    background-image: url('../assets/img/bg-home-1.jpg')
    background-size: cover
    position: relative
    +media-min-md
      min-height: 95vh
    +media-min-lg
    &_center-text
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      .image
        width: 40%
        +media-min-md
          width: auto
          max-width: 100%
  &__banner-2
    background-image: url('../assets/img/bg-home-2.jpg')
    background-size: cover
    min-height: 570px
    position: relative
    overflow: hidden
    background-position: right
    +media-min-md
      background-position: center
      background-size: cover
      min-height: 100vh
    &_text
      position: absolute
      line-height: 25px
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
      width: 100%
      +media-min-md
        left: 12%
        top: 35%
        width: auto
        transform: translate(0, -50%)
        left: 12%
        line-height: 35px
      h3
        font-size: 25px
        +media-min-md
          font-size: 35px
      .v-btn
        margin-top: 15px
        letter-spacing: normal
        font-size: 1.1rem
        +media-min-md
          font-size: 2rem

  &__cards-content
    padding: 50px 0
    .image
      width: 25%

  &__totem-content
    position: relative
    padding: 50px 0
    +media-min-sm
      padding: 150px 0
    +media-min-md
      padding: 300px 0 150px 0
    .image
      position: absolute
      top: 50%
      transform: translateY(-50%)
      width: 18%
      left: 5%
      +media-min-md
        top: 55%
        width: 15%
        left: 15%
  &__totem-line
    width: 100%
    height: 220px
    background: $primary
    line-height: 50px
    .totem-text
      position: absolute
      line-height: 25px
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
      +media-min-md
        top: 60%
        transform: translate(0, -50%)
        right: 18%
        line-height: 40px
      h3
        font-size: 25px
        +media-min-md
          font-size: 40px
      .v-btn
        margin-top: 15px
        letter-spacing: normal
        font-size: 1.1rem
        +media-min-md
          font-size: 2rem

  &__rbx-content
    position: relative
    .image
      position: relative
      width: 45%
      top: -20px
      +media-min-md
        width: 35%

</style>